export default {
  name: "ResetPassword",

  data() {
    return ({
      email: "",
      is_loading: false,
      error_message: "",
      success_message: "",
    });
  },

  methods: {
    async handleReset() {
      const RESET_PASSWORD_URL = process.env.VUE_APP_RESET_PASSWORD
      this.error_message = "";
      this.success_message = "";
      this.is_loading = true;

      try {
        // API CALL EXAMPLE (replace with your actual endpoint)
        const response = await fetch(RESET_PASSWORD_URL, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ email: this.email ,client_app: "dws"}),
        })
        //When the reset password is success
        if(response.ok) {
          this.success_message = "A password reset link has been sent to your email.";
        }

      } catch (error) {
        this.error_message = "Unable to send reset link. Please try again.";
      } finally {
        this.is_loading = false;
      }
    }
  }
};
